export const dealergraph = {
  "dealergraph.change": "dealergraph.change",
  "dealergraph.create": "dealergraph.create",
  "dealergraph.upload": "dealergraph.upload",
  "dealergraph.upload.accept": "dealergraph.upload.accept",
  "dealergraph.user.add": "dealergraph.user.add",
  "dealergraph.user.delete": "dealergraph.user.delete",
  "dealergraph.domain.create": "dealergraph.domain.create",
  "dealergraph.domain.delete": "dealergraph.domain.delete",
  "dealergraph.projectDocumentation.set":
    "dealergraph.projectDocumentation.set",
  "dealergraph.field.change": "dealergraph.field.change",
  "dealergraph.get": "dealergraph.get",
  "dealergraph.list.get": "dealergraph.list.get",
  "dealergraph.my.get": "dealergraph.my.get",
  "dealergraph.holdings.get": "dealergraph.holdings.get",
  "dealergraph.forUser.get": "dealergraph.forUser.get",
  "dealergraph.toAssign.get": "dealergraph.toAssign.get",
  "dealergraph.projectDocumentation.get":
    "dealergraph.projectDocumentation.get",
  "dealergraph.projectDocumentations.get":
    "dealergraph.projectDocumentations.get",
  "dealergraph.area.get": "dealergraph.area.get",
  "dealergraph.regions.get": "dealergraph.regions.get",
  "dealergraph.cities.get": "dealergraph.cities.get",
  "dealergraph.federalArea.get": "dealergraph.federalArea.get",
  "dealergraph.locationItem.get": "dealergraph.locationItem.get",
  "dealergraph.download": "dealergraph.download",
  "dealergraph.freeId.get": "dealergraph.freeId.get",
  "dealergraph.domains.get": "dealergraph.domains.get",
  "dealergraph.domains.all.get": "dealergraph.domains.all.get",
  "dealergraph.domain.check": "dealergraph.domain.check",
  "dealergraph.email.check": "dealergraph.email.check",
  "dealergraph.emailMismatchReport.get": "dealergraph.emailMismatchReport.get",
  "dealergraph.fields.get": "dealergraph.fields.get",
} as const;
